import React from "react";
import { toast } from "react-toastify";
import { Navigate } from "react-router-dom";

// Hook
import { useAuth } from "../hooks/useAuth";

// Helpers
import { delLocalStorage } from "../helpers/appHelper";
import { checkAuth } from "../helpers/authHelper";

export default function Protected({ children }) {
  const { auth, setAuth } = useAuth();

  const { refresh_token_expired } = checkAuth(auth.token);

  React.useEffect(() => {
    if (refresh_token_expired) {
      delLocalStorage();

      setAuth((prev) => {
        return {
          ...prev,
          token: null,
          user: null,
        };
      });

      toast.info("Your session has expired. Please sign in again.");
    }
  }, [refresh_token_expired, setAuth]);

  return !refresh_token_expired ? children : <Navigate to="/signin" replace />;
}
